/** Keep signup rewards distinct from sale/subscription commission and avoid double counting. */
export function includeSignupRewards<T extends { sellTotalAmount: number; buyTotalAmount: number }>(metrics: T, rawReward: unknown) {
  const reward = Number(rawReward ?? 0);
  const signupReferralEarnings = Number.isFinite(reward) ? reward : 0;
  return {
    ...metrics,
    signupReferralEarnings,
    totalAmount: metrics.sellTotalAmount + metrics.buyTotalAmount + signupReferralEarnings,
  };
}
